<div class="options-introduction d-flex align-items-center v-scrollbar" atlWindowInnerHeight>
  <atl-shadow-dom-content class="mt-32" *ngIf="introduction$ | async as intro">
    <div
      *ngIf="intro?.description"
      class="options-introduction__content"
      [innerHTML]="intro.description | safeHtml"
    ></div>
  </atl-shadow-dom-content>
</div>

<div class="options-introduction__footer d-flex align-items-center justify-content-center">
  <button (click)="openFirstCategory()" class="global-button options-introduction__footer-button newest-button">
    {{ 'Button.Get_started_newer' | translate }}
  </button>
</div>
